import React from 'react';

import { BingoList } from './components/BingoList';
import { CategoryTitle } from './components/CategoryTitle';
import { GameList } from './components/GameList';

import { DYNAMIC_CATEGORIES } from 'js/app/components/main/Games/constants';
import { useIsAllCategories } from 'js/app/components/main/Games/hooks/useIsAllCategories';
import { useGamesSelector } from 'js/app/components/main/Games/store/context';

export const GameCategory = ({ category }) => {
    const { isShowBack } = useGamesSelector();
    const isAllCategories = useIsAllCategories();
    const CategoryList = category.isBingoList ? BingoList : GameList;

    return (
        <>
            {(isShowBack || isAllCategories) && (
                <CategoryTitle
                    category={category}
                    targetCategoryName={isAllCategories ? category.name : DYNAMIC_CATEGORIES.ALL_CATEGORY}
                />
            )}

            <CategoryList category={category} />
        </>
    );
};
